/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

export enum DeviceCategory {
  ANDROID_DEVICE = 'AND',
  APPLE_DEVICE = 'APL',
  CHROMECAST = 'CHR',
  DESKTOP_APP = 'DSKAPP',
  DEVICE_SIMULATOR = 'SIMULATOR',
  KAIOS_DEVICE = 'KAIOS',
  LG_TV = 'LGTV',
  NINTENDO = 'NINTENDO',
  PLAYSTATION = 'PS',
  ROKU = 'RK',
  SAMSUNG_TV = 'SAMSUNGTV',
  SET_TOP_BOX = 'STB',
  SMART_TV = 'TV',
  TIVO = 'TIVO',
  WEB = 'WEB',
  WINDOWS_DEVICE = "WIN'",
  XBOX = 'XB',
  LINUX = 'LNX',
}
